<template>
<div style="width:100%">
  <van-collapse v-model="activeNames">
    <van-collapse-item title="发票信息" name="1">
      <van-field v-model="inputForm.typeLabel" label="发票种类" label-width="120px"
                 readonly input-align="left" :border="false" />
      <van-field v-model="inputForm.invoice.invoiceNum" label="发票号码" label-width="120px"
                 readonly input-align="left" :border="false" />

      <van-field v-model="inputForm.invoice.totalTax" label="税额（元）" :formatter="formatter" label-width="120px"
                 readonly input-align="left" :border="false" />
      <van-field v-model="inputForm.invoice.amount" label="价税合计小写" :formatter="formatter" label-width="120px"
                 readonly input-align="left" :border="false" />
      <van-field v-model="inputForm.invoice.purchaserName" label="购买方名称" label-width="120px"
                 readonly input-align="left" :border="false" />
      <van-field v-model="inputForm.invoice.sellerName" label="销售方名称" label-width="120px"
                 readonly input-align="left" :border="false" />
      <van-field v-model="inputForm.invoiceDetail.invoice_date" label="开票日期" label-width="120px"
                 readonly input-align="left" :border="false" />


      <div style="padding-left: 16px;" v-show="inputForm.invoiceDetail.attachList&&inputForm.invoiceDetail.attachList.length > 0">
        <p>附件</p>
        <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.invoiceDetail.attachList" :key="index"
           @click="$viewAttach(file)">{{ file.name }}</p>
      </div>
    </van-collapse-item>
<!--    <van-collapse-item title="业务信息" name="3">-->

<!--      <div style="padding-left: 16px;" v-show="inputForm.invoiceDetail.attachList&&inputForm.invoiceDetail.attachList.length > 0">-->
<!--        <p>附件</p>-->
<!--        <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.invoiceDetail.attachList" :key="index"-->
<!--           @click="$viewAttach(file)">{{ file.name }}</p>-->
<!--      </div>-->
<!--    </van-collapse-item>-->
  </van-collapse>
</div>
</template>

<script>
import QueryInfoService from "@/api/system/queryInfoService";

export default {
  name: "vehicleInvoiceFlowForm",
  data(){
    return {
      inputForm:{
        invoiceDetail:{}
      },
      activeNames: ['1', '2']
    }
  },
  methods: {
    init(data){
      this.inputForm = data
      this.inputForm.type = data.invoice.type
      this.getDict([
        ['cost_invoice_type', 'type'],
      ]);
    },
    getDict(dicts){
      new QueryInfoService().getDictMap().then(({data}) => {
        dicts.map(([dictType, formField]) => {
          this.$set(this.inputForm, `${formField}Label`, data[dictType].find(item=>item.value==this.inputForm[formField]).label);
        });
      }).catch(e => {
        console.log(e)
      })
    },
    formatter(value){
      return Number(value).toFixed(2)
    }
  }
}
</script>

<style scoped>

</style>